import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f7a2d9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../asset/css/index.scss?vue&type=style&index=0&id=4f7a2d9b&prod&lang=scss&scoped=true&external"
import style1 from "../../gpt/assets/css/index.scss?vue&type=style&index=1&id=4f7a2d9b&prod&lang=scss&scoped=true&external"
import style2 from "./index.vue?vue&type=style&index=2&id=4f7a2d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a2d9b",
  null
  
)

export default component.exports